// Checkout URLs for each pack — easy to update from one place
export const CHECKOUT_URLS = {
  profesional:
    'https://profelisto.com.ar/checkouts/cn/hWNDHFL5xQJcfrCwluP3r8ra/es-ar?_r=AQABmA2NUjvG8U1ssXAKyYm3zt7bb-PRMZ-yobB8aNnSRsk',
  elite:
    'https://profelisto.com.ar/checkouts/cn/hWNDHFREgLoiWzeBJblfXrz0/es-ar?_r=AQAB4hhpmZmol-CGKqO2nVNJbZkjc5haECMqyS7b5kgDBOM',
} as const

export type PackId = keyof typeof CHECKOUT_URLS

export function goToCheckout(packId: PackId): void {
  if (typeof window === 'undefined') return
  window.location.href = CHECKOUT_URLS[packId]
}
